module.exports = __webpack_public_path__ + "static/background 1-17d8e91c976f6cf535fb8392ae4810d2.svg";